module.exports = __webpack_public_path__ + "img/facebook-f-brands.41fcce62.svg";